<template>
  <div v-cloak id="add-order">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <form>
          <div class="vx-row" v-if="agentCreditLoaded">
            <div class="vx-col sm:w-1/3 w-full mt-6">
              <vs-alert active="true">
                اعتبار در تدبیر:
                {{ Number(agentCredit.tadbirCredit).toLocaleString() }} ریال
              </vs-alert>
            </div>
            <div class="vx-col sm:w-1/3 w-full mt-6">
              <vs-alert active="true">
                جمع مبلغ سفارشات باز:
                {{ Number(agentCredit.debit).toLocaleString() }} ریال
              </vs-alert>
            </div>
            <div class="vx-col sm:w-1/3 w-full mt-6">
              <vs-alert active="true">
                اعتبار قابل استفاده:
                {{ Number(agentCredit.logicalCredit).toLocaleString() }} ریال
              </vs-alert>
            </div>
          </div>
          <loading v-if="showLoading"></loading>
          <div class="vx-row my-2 flex items-end">
            <div
              class="vx-col w-full"
              :class="agentCreditLoaded ? 'sm:w-1/3' : 'sm:w-1/4 '"
            >
              <label class="vs-select--label">{{ $t("AgentName") }}</label>
              <treeselect
                v-model="model.agent"
                name="agent"
                :multiple="false"
                :placeholder="$t('SearchAgent')"
                :async="true"
                :load-options="loadAgentOptions"
                :disabled="model.agent != null"
                v-validate="'required'"
                v-if="modify"
                @select="onAgentSelected"
              />
              <vs-input
                class="inputx mt-1"
                v-else
                v-model="agentLabel"
                readonly="readonly"
              />
            </div>
            <div
              class="vx-col w-full mt-1"
              v-has-permission="permission515"
              v-if="agentCreditLoaded && memberAgentPermission"
              :class="agentCreditLoaded ? 'sm:w-1/3' : 'sm:w-1/4 '"
            >
              <label class="vs-select--label my-1">{{ $t("Members") }}</label>
              <v-select
                label="name"
                :options="listOfMembersFromAgent"
                v-model="userFromAgent"
                :reduce="(x) => x.id"
                :clearable="false"
                ref="agentType"
                dir="rtl"
                @input="onMemberSelected"
              >
              </v-select>
            </div>
            <div
              class="vx-col w-full mt-1"
              :class="agentCreditLoaded ? 'sm:w-1/3' : 'sm:w-1/4 '"
              v-show="model.agent || !modify"
            >
              <label class="vs-select--label">{{ $t("Product") }}</label>
              <v-select
                label="persianName"
                name="product"
                :options="agentProducts"
                @input="onProductSelected"
                ref="productSelection"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('product')"
                >{{ errors.first("product") }}</span
              >
            </div>
            <div
              class="vx-col mt-6 w-full"
              :class="agentCreditLoaded ? 'sm:w-auto' : 'sm:w-3/4'"
              style="float: right !important"
            >
              <vs-button
                @click.prevent="uploadFile()"
                class="bg_m_green float-right"
                v-if="fileUploaded"
                :disabled="disabledBtn"
                v-has-permission="permission315"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("UploadFile") }}
              </vs-button>
              <label class="custom-file-upload">
                <input
                  type="file"
                  id="file"
                  ref="file"
                  v-on:change="handleFileUpload()"
                />

                <feather-icon
                  icon="PaperclipIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("ChooseGetBasketFile") }}
                <span v-if="uploadedFileName" class="file-name">{{
                  uploadedFileName
                }}</span>
              </label>
            </div>
          </div>
        </form>
        <div class="vx-row">
          <div class="vx-col w-full mb-2 mt-4">
            <vs-table :data="info" class="custom-tbl">
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 40%">{{ $t("ProductName") }}</th>
                <th style="width: 15%">{{ $t("Price") }}</th>
                <th style="width: 15%">{{ $t("ItemCode") }}</th>
                <th style="width: 10%">{{ $t("Count") }}</th>
                <th style="width: 15%">{{ $t("Action") }}</th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="i" v-for="(index, i) in data">
                  <vs-td>
                    {{ i + 1 }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].name }}
                  </vs-td>
                  <vs-td>
                    {{ Number(data[i].price).toLocaleString()
                    }}{{ $t("Rials") }}
                  </vs-td>

                  <vs-td>
                    {{ data[i].itemCode }}
                  </vs-td>
                  <vs-td class="count-input">
                    <vs-input
                      v-model="data[i].count"
                      name="count"
                      v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
                      :class="{ 'is-invalid': errors.has('count') }"
                    />
                  </vs-td>
                  <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deletePro(data[i], i)"
                      class="d-inline"
                    ></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2 justify-end mt-6 flex gap-4">
            <vs-button
              type="filled"
              color="#3ec9d6"
              @click.prevent="resetForm"
              >{{ $t("Reset") }}</vs-button
            >
            <vs-button
              type="filled"
              @click.prevent="submitForm"
              :disabled="disabled"
              v-if="info.length"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
        <!-- <div>
          <span v-if="writeDateSettlement" class="text-danger">
            *تاریخ تسویه را وارد کنید
          </span>
          <span
            v-if="writeDateSettlementForExcel && !DateSettlement"
            class="text-danger"
          >
            *وارد کردن تاریخ تسویه الزامی است
            <br />
            *در صورت نیاز توضیحات را وارد نمایید
          </span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}

#loading {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff7d;
  z-index: 999;
}

.vue-treeselect--disabled .vue-treeselect__control {
  padding: 0.19rem 0.7rem !important;
}

.vue-treeselect--disabled
  .vue-treeselect__control
  .vue-treeselect__value-container {
  top: 0px;
}

#add-order .is-invalid input {
  border-color: red !important;
}

.count-input input {
  text-align: center !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import vSelect from "@/components/CustomVSelect.vue";
import Treeselect from "@/components/CustomTreeSelect.vue";
import Loading from "@/components/loading/Loading.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

export default {
  name: "basketManagement_ChannelBaskets_AddBasket",
  components: {
    "v-select": vSelect,
    Treeselect,
    Loading,
  },
  data() {
    return {
      memberAgentPermission: false,
      permission315: "CreateBasketByExcelFile",
      permission515: "GetMembersOfAgent",
      listOfMembersFromAgent: [],
      showLoading: false,
      model: {
        agent: null,
        productId: null,
      },
      info: [],
      disabled: false,
      basketModel: {
        agentId: null,
        basketItems: [
          {
            productId: null,
            count: null,
          },
        ],
      },
      modify: true,
      agentLabel: "",
      agentCreditLoaded: false,
      userFromAgent: "",
      searchQueryNew: "",
      searchQueryOld: "",
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      updateLoading: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
      agentProducts: [],
    };
  },
  computed: {
    ...mapGetters({
      agentCredit: "sale/agentCreditDetails",
      originalAgentProducts: "sale/agentProducts",
    }),
  },
  created() {
    var permissionList = localStorage.getItem("permissions").split(",");
    if (permissionList.includes("GetMembersOfAgent")) {
      this.memberAgentPermission = true;
    }
  },

  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
    if (this.$route.query.AgentId) {
      this.agentLabel = this.$route.query.AgentName;
      this.modify = false;
      var agentId = this.$route.query.AgentId;
      this.basketModel.agentId = agentId;
      this.fetchAgentCredit(agentId);
      this.agentCreditLoaded = true;
      this.fetchAgentProducts(agentId).then((response) => {
        this.agentProducts = [...response];
      });
      if (this.memberAgentPermission) {
        this.createListMemberOfAgent(agentId);
      }
    }
  },
  methods: {
    ...mapActions({
      currentUserAgentSearch: "parties/channelCurrentUserAgentsSearch",
      membersFromAgent: "parties/membersFromAgent",
      addBasket: "basket/addSaleAgentBasket",
      fetchAgentCredit: "sale/fetchAgentCredit",
      fetchAgentProducts: "sale/fetchAgentProducts",
      importProductInBasketExcel: "excel/importProductInBasketExcel",
    }),

    loadAgentOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.currentUserAgentSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  ownerUserId: element.ownerUserId,
                  name: element.name,
                  label: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    resetForm() {
      this.$router.go(this.$router.currentRoute);
    },
    onProductSelected(data) {
      if (data) {
        var array = this.info;
        var alreadyExisted = array.findIndex(
          (x) => x.itemCode == data.itemCode
        );
        if (alreadyExisted === -1) {
          array.push({
            name: data.persianName,
            productId: data.productId,
            price: data.price,
            itemCode: data.itemCode,
          });
          // remove from dropdown:
          const indexToRemove = this.agentProducts.findIndex(
            (item) => item.itemCode == data.itemCode
          );
          this.agentProducts.splice(indexToRemove, 1);
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "کالا با این آیتم کد در لیست انتخابی از قبل موجود است!!",
            showConfirmButton: false,
            timer: 8000,
          });
        }
        this.$refs.productSelection.clearSelection();
      }
    },
    onMemberSelected(data) {
      this.basketModel.partyId = data;
    },
    createListMemberOfAgent(agentId) {
      this.membersFromAgent(agentId).then((r) => {
        this.agentCreditLoaded = true;
        this.listOfMembersFromAgent.push({
          name: "-",
          id: "",
        });
        r.data.forEach((elem) => {
          this.listOfMembersFromAgent.push({
            name: elem.name + " - " + this.getNationalCode(elem),
            id: elem.partyId,
          });
        });
        this.showLoading = false;
      });
    },
    getNationalCode(elemObj) {
      return elemObj.socialSecurityNumber
        ? elemObj.socialSecurityNumber
        : elemObj.companyNationalId;
    },
    onAgentSelected(data) {
      this.showLoading = true;
      this.basketModel.agentId = data.id;
      this.fetchAgentCredit(data.id).then(() => {
        this.agentCreditLoaded = true;
      });
      this.createListMemberOfAgent(data.id);
      this.fetchAgentProducts(data.id).then((response) => {
        this.agentProducts = [...response];
      });
    },
    deletePro(itemToDelete, indexToDelete) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.info.splice(indexToDelete, 1),
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
          // add back to dropdown:
          const itemToAddBackToDropdown = this.originalAgentProducts.find(
            (product) => product.itemCode == itemToDelete.itemCode
          );
          this.agentProducts.push(itemToAddBackToDropdown);
        }
      });
    },
    submitForm() {
      this.basketModel.basketItems = this.info;
      if (!this.basketModel.ownerIdOfMember) {
        delete this.basketModel.ownerIdOfMember;
      }
      this.disabled = true;
      this.addBasket(this.basketModel).then(() => {
        this.$router.push({
          path: "/ChannelBaskets/Index",
          query: {
            referencePageInfo: {
              tabIndex: 0,
              numberRowsPerPage: this.$route.query.numberRowsPerPage,
            },
          },
        });
      });
      this.disabled = false;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.$refs.file.files[0].name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      var agentId = this.basketModel.agentId;
      var partyId = null;
      this.updateLoading = true;
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("File", this.file);
      if (this.basketModel.partyId) {
        partyId = this.basketModel.partyId;
      }
      this.importProductInBasketExcel({
        formData,
        agentId,
        partyId,
      }).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.updateLoading = false;
        this.disabledBtn = false;
      }, 1000);
    },
  },
};
</script>
